type Camera = { lat?: number; lng?: number; zoom?: number };

/**
 * What to change on the map when the `center`/`zoom` props change. A center
 * that arrives after mount (the organisation loads after the map) brings its
 * zoom along: the map started without either, so the zoom was never applied.
 */
export function cameraMoves(previous: Camera, next: Camera) {
  const hasCenter = next.lat !== undefined && next.lng !== undefined;
  const firstCenter = hasCenter && previous.lat === undefined;
  const centerMoved =
    hasCenter && (next.lat !== previous.lat || next.lng !== previous.lng);
  const zoomChanged =
    next.zoom !== undefined && (next.zoom !== previous.zoom || firstCenter);

  return {
    center: centerMoved ? { lat: next.lat!, lng: next.lng! } : null,
    zoom: zoomChanged ? next.zoom! : null,
  };
}

type Box = { top: number; left: number; right: number };

/**
 * How far to pan so an open popup sits inside the map, `margin` px from its
 * edges, as `[x, y]` for `map.panBy`. Only the top and sides: the popup opens
 * above its pin, which is already on the map.
 */
export function popupPan(popup: Box, map: Box, margin = 12): [number, number] {
  let x = 0;
  if (popup.left < map.left + margin) {
    x = popup.left - map.left - margin;
  } else if (popup.right > map.right - margin) {
    x = popup.right - map.right + margin;
  }
  const y = Math.min(0, popup.top - map.top - margin);

  return [x, y];
}
